import ProjectProperties from "../project-properties"
import projectProperties_toJSON from "../functions/properties-to-json";
import ProjectSession from "../../project-session"
import {ProjectPropertiesData} from "../../types"

const DEFAULT = {
    canCreateTask           : true,
    canCreateProject        : true,
    // canCreatePage           : true,
    canCreateLink           : true,
    canCreateEmbed          : true,
    canCreateMeeting        : true,
    canCreateEvent          : true,
    canCreateDiscussion     : true,
    canCreateDocument       : true,
    canCreateGoal           : true,
    canCreateDashboard      : true,
    canCreateRequestForms   : true,
    canCreateAttachments    : true,
    canHaveStatus           : true,
}

export default class ProjectDefaultProperties extends ProjectProperties {

    constructor(properties:any, project: ProjectSession) {
        super(properties, project)

        this.canCreateTask          = _.get(properties,'canCreateTask', DEFAULT.canCreateTask)
        this.canCreateProject       = _.get(properties,'canCreateProject', DEFAULT.canCreateProject)
        // this.canCreatePage          = _.get(properties,'canCreatePage', DEFAULT.canCreatePage)
        this.canCreateLink          = _.get(properties,'canCreateLink', DEFAULT.canCreateLink)
        this.canCreateEmbed         = _.get(properties,'canCreateEmbed', DEFAULT.canCreateEmbed)
        this.canCreateMeeting       = _.get(properties,'canCreateMeeting', DEFAULT.canCreateMeeting)
        this.canCreateEvent         = _.get(properties,'canCreateEvent', DEFAULT.canCreateEvent)
        this.canCreateDiscussion    = _.get(properties,'canCreateDiscussion', DEFAULT.canCreateDiscussion)
        this.canCreateDocument      = _.get(properties,'canCreateDocument', DEFAULT.canCreateDocument)
        this.canCreateGoal          = _.get(properties,'canCreateGoal', DEFAULT.canCreateGoal)
        this.canCreateDashboard     = _.get(properties,'canCreateDashboard', DEFAULT.canCreateDashboard)
        this.canCreateRequestForms  = _.get(properties,'canCreateRequestForms', DEFAULT.canCreateRequestForms)
        this.canCreateAttachments   = _.get(properties,'canCreateAttachments', DEFAULT.canCreateAttachments)
    }

    toJSON(): ProjectPropertiesData {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
